
(function nonBubblingClickDefinition() {

    angular.module('NonBubblingClick', []);

})();